import { format } from "date-fns";

export const formatDateAndTime = (isoString) => {
  const date = new Date(isoString);

  // Format the date as "dd-MM-yyyy at hh:mm"
  return format(date, "dd/MM/yyyy '-' hh:mm a");
};
